import Vue from 'vue';
import VueRouter from 'vue-router';

//import store from '../store/index.js';

const HealthCheck = () => import(/* webpackChunkName: "merchants" */ '../views/HealthCheck.vue');
// Layouts
const DefaultLayout = () => import(/* webpackChunkName: "default" */ '../layouts/Default.vue');
// Views
const Merchants = () => import(/* webpackChunkName: "merchants" */ '../views/Merchants/index.vue');
const MerchantImport = () => import(/* webpackChunkName: "merchant-import" */ '../views/Merchants/import.vue');

const ViewIndex = () => import(/* webpackChunkName: "merchant-add" */ '../views/Merchants/view/index.vue');
const MerchantBranches = () => import(/* webpackChunkName: "merchant-branches" */ '../views/Merchants/view/branches.vue');
const MerchantViewQR = () => import(/* webpackChunkName: "merchant-view-qr" */ '../views/Merchants/view/qr/index.vue');
const MerchantAction = () => import(/* webpackChunkName: "merchant-add" */ '../views/Merchants/action.vue');

const AuditTrails = () => import(/* webpackChunkName: "audit-trails" */ '../views/AuditTrails/index.vue');
const AuditTrailsDetails = () => import(/* webpackChunkName: "audit-trails-details" */ '../views/AuditTrails/details.vue');

// User Access
const UserAccess = () => import(/* webpackChunkName: "user-access" */ '../views/UserAccess/index.vue');
const UserAccessAction = () => import(/* webpackChunkName: "user-access-action" */ '../views/UserAccess/users/_action.vue');
const RoleAction = () => import(/* webpackChunkName: "user-access-action" */ '../views/UserAccess/roles/_action.vue');

const SystemVariables = () => import(/* webpackChunkName: "system-variables" */ '../views/SystemVariables/index.vue');
const SystemVariablesView = () => import(/* webpackChunkName: "system-variables-view" */ '../views/SystemVariables/_action.vue');
// Partner Role
// const MyQR = () => import(/* webpackChunkName: "my-qr" */ '../views/MyQR/index.vue');

// Branches
const Branches = () => import(/* webpackChunkName: "branches" */ '../views/Branches/index.vue');
const BranchAction = () => import(/* webpackChunkName: "branches-action" */ '../views/Branches/action.vue');
const BranchesImport = () => import(/* webpackChunkName: "branches-import" */ '../views/Branches/import.vue');
const BranchDetails = () => import(/* webpackChunkName: "branches-details" */ '../views/Branches/details.vue');

const Login = () => import(/* webpackChunkName: "login" */ '../views/Login.vue');
const PageNotFound = () => import(/* webpackChunkName: "error-page" */ '../components/Core/ErrorPage.vue');
const Register = () => import(/* webpackChunkName: "register" */ '../views/Register.vue');
const ForgotPassword = () => import(/* webpackChunkName: "forgot-password" */ '../views/ForgotPassword.vue');
const PasswordReset = () => import(/* webpackChunkName: "password-reset" */ '../views/PasswordReset.vue');
const DashBoard = () => import(/* webpackChunkName: "dashboard" */ '../components/Core/DashBoard.vue');

// External
const ExternalMerchantsID = () => import(/* webpackChunkName: "external-merchants-id" */ '../views/External/Merchants/id.vue');
const ExternalMerchantsByMobile = () => import(/* webpackChunkName: "external-merchants-by-mobile" */ '../views/External/Merchants/mobile.vue');

const vue = new Vue({
    name: 'router'
});

Vue.use(VueRouter);

const routes = [
    {
        path: '/health-check',
        name: 'health-check',
        // redirect: { name: 'login' },
        component: HealthCheck,
        meta: { requiresAuthentication: false, title: 'Health Check' }
    },
    {
        path: '/external/merchants/:id',
        name: 'external-merchants',
        component: ExternalMerchantsID,
        meta: {
            requiresAuthentication: false
        }
    },
    {
        path: '/external/merchants/by-mobile/:mobile',
        name: 'external-merchants-by-mobile',
        component: ExternalMerchantsByMobile,
        meta: {
            requiresAuthentication: false
        }
    },
    {
        path: '/login',
        name: 'login',
        // redirect: { name: 'login' },
        component: Login,
        meta: { requiresAuthentication: false, title: 'Login' }
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: { requiresAuthentication: false, title: 'Register' }
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: ForgotPassword,
        meta: { requiresAuthentication: false, title: 'Forgot Password' }
    },
    {
        path: '/password-reset',
        name: 'password-reset',
        component: PasswordReset,
        meta: { requiresAuthentication: false, title: 'Password Reset' }
    },
    {
        path: '/merchants/qr/:id',
        name: 'merchants-view-qr',
        component: MerchantViewQR,
        meta: {
            requiresAuthentication: true,
            title: 'View QR',
            action_id: 'merchants-qr-show'
        }
    },
    {
        path: '/',
        name: 'default-layout',
        component: DefaultLayout,
        redirect: { name: 'merchants' },
        children: [
            // Hierarchy: List, Import, View, Action(Add/Edit)
            // Merchants - Main
            {
                path: '/merchants',
                name: 'merchants',
                component: Merchants,
                meta: {
                    requiresAuthentication: true,
                    title: 'Merchants',
                    action_id: 'merchants-index',
                    sequence: 1
                }
            },
            {
                path: '/merchants/import',
                name: 'merchant-import',
                component: MerchantImport,
                meta: {
                    requiresAuthentication: true,
                    title: 'Merchant - Import from a File(Batch Upload)',
                    action_id: 'import_file_uploads-index'
                }
            },
            {
                path: '/merchants/view/:id',
                name: 'view-merchant',
                component: ViewIndex,
                meta: {
                    requiresAuthentication: true,
                    title: 'View Merchant',
                    action_id: 'merchants-show'
                }
            },
            {
                path: '/merchants/:action(add|edit)/:id?',
                name: 'merchant-action',
                component: MerchantAction,
                meta: {
                    requiresAuthentication: true,
                    title: (route) => {
                        if (route.params.action == 'add') {
                            return 'Merchant - Add Manually';
                        }
                        return 'Edit Merchant';
                    },
                    action_id: {
                        add: 'merchants-store',
                        edit: 'merchants-update',
                        view: ''
                    }
                }
            },
            // Merchants - Branches
            {
                path: '/merchants/view/:id/branches',
                name: 'merchant-branches',
                component: MerchantBranches,
                meta: {
                    requiresAuthentication: true,
                    title: 'Merchants - Branch List',
                    action_id: 'merchants-branches-index'
                }
            },
            {
                path: '/merchants/view/:id/branches/import',
                name: 'merchant-branch-import',
                component: BranchesImport,
                meta: {
                    requiresAuthentication: true,
                    title: 'Add Merchant Branch - Import from a File(Batch Upload)',
                    action_id: 'merchants-branches-import'
                }
            },
            {
                path: '/merchants/view/:id/branches/view/:branch',
                name: 'merchant-branch-view',
                component: BranchDetails,
                meta: {
                    requiresAuthentication: true,
                    title: 'View Merchant Branch',
                    action_id: 'merchants-branches-index'
                }
            },
            {
                path: '/merchants/view/:id/branches/:action(add|edit)/:branch?',
                name: 'merchant-branch-action',
                component: BranchAction,
                meta: {
                    requiresAuthentication: true,
                    title: (route) => {
                        if (route.params.action == 'add') {
                            return 'Merchant Branch - Add Manually';
                        }
                        return 'Edit Merchant Branch';
                    },
                    action_id: {
                        add: 'merchants-branches-store',
                        edit: 'merchants-update'
                    }
                }
            },
            // Merchant Login - My QR
            {
                path: '/my-qr',
                name: 'my-qr',
                component: ViewIndex,
                meta: {
                    requiresAuthentication: true,
                    title: 'My QR',
                    action_id: 'my-merchant-index',
                    sequence: 2
                }
            },
            // Merchant Login - Branches
            {
                path: '/branches',
                name: 'branches',
                component: Branches,
                meta: {
                    requiresAuthentication: true,
                    title: 'Branches',
                    action_id: 'my-merchant-branches-index',
                    sequence: 3
                }
            },
            {
                path: '/branches/import',
                name: 'branches-import',
                component: BranchesImport,
                meta: {
                    requiresAuthentication: true,
                    title: 'Branch - Import from a File(Batch Upload)',
                    action_id: 'merchants-branches-import'
                }
            },
            {
                path: '/branches/view/:branch',
                name: 'branches-view',
                component: BranchDetails,
                meta: {
                    requiresAuthentication: true,
                    title: 'View Branch',
                    action_id: 'merchants-show'
                }
            },
            {
                path: '/branches/:action(add|edit)/:branch?',
                name: 'branches-action',
                component: BranchAction,
                meta: {
                    requiresAuthentication: true,
                    title: (route) => {
                        if (route.params.action == 'add') {
                            return 'Branch - Add Manually';
                        }
                        return 'Edit Branch';
                    },
                    action_id: {
                        add: 'merchants-branches-store',
                        edit: 'merchants-update'
                    }
                }
            },
            // Audit Trails
            {
                path: 'audit-trails',
                name: 'audit-trails',
                component: AuditTrails,
                meta: {
                    requiresAuthentication: true,
                    title: 'Audit Trails',
                    action_id: 'cms_audit_logs-index',
                    sequence: 4
                }
            },
            {
                path: 'audit-trails/:id',
                name: 'audit-trails-details',
                component: AuditTrailsDetails,
                meta: {
                    requiresAuthentication: true,
                    title: 'Audit Trails Details',
                    action_id: 'cms_audit_logs-show'
                }
            },
            // User Access - Users
            {
                path: 'user-access',
                name: 'user-access',
                component: UserAccess,
                meta: {
                    requiresAuthentication: true,
                    title: 'User Access',
                    action_id: 'cms_users-index',
                    sequence: 5
                }
            },
            {
                path: '/user-access/users/:action(invite-user|create|view|edit)/:id?',
                name: 'user-access-action',
                component: UserAccessAction,
                meta: {
                    requiresAuthentication: true,
                    title: (route) => {
                        if (route.params.action == 'invite-user') {
                            return 'Invite User';
                        }
                        return route.params.action + ' User';
                    },
                    action_id: {
                        create: 'cms_users-store',
                        edit: 'cms_users-update',
                        'invite-user': 'cms_users-invite',
                        view: 'cms_users-show'
                    }
                }
            },
            // User Access - Roles
            {
                path: '/user-access/roles/:action(add|view|edit)/:id?',
                name: 'roles-action',
                component: RoleAction,
                meta: {
                    requiresAuthentication: true,
                    title: (route) => {
                        return route.params.action + ' Role';
                    },
                    action_id: {
                        add: 'cms_roles-store',
                        edit: 'cms_roles-update',
                        view: 'cms_roles-show'
                    }
                }
            },
            // System Variables
            {
                path: 'system-variables',
                name: 'system-variables',
                component: SystemVariables,
                meta: {
                    requiresAuthentication: true,
                    title: 'System Variables',
                    action_id: 'system_variables',
                    sequence: 6
                }
            },
            {
                path: 'system-variables/:action/:id',
                name: 'system-variables-view',
                component: SystemVariablesView,
                meta: {
                    requiresAuthentication: true,
                    title: 'System Variables',
                    action_id: 'test'
                }
            },
            {
                path: 'dashboard',
                component: DashBoard,
                name: 'dashboard',
                meta: {
                    title: 'Dashboard',
                    requiresAuthentication: true,
                    action_id: 'dashboard'
                }
            },
            // Not Found
            {
                path: '404',
                name: 'page-not-found',
                component: PageNotFound,
                meta: {
                    requiresAuthentication: true,
                    action_id: 'test'
                }
            },
            {
                path: '*',
                redirect: '/404',
                meta: {
                    action_id: 'test'
                }
            }
        ]
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.afterEach(() => {
    vue.$cookies.set('permission', null);
});

router.beforeEach((to, from, next) => {
    // console.log(to, from, next);

    vue.$api.cancelCurrentApiCall();

    const token = vue.$cookies.get('token');

    // Dynamic Module Title
    if (to.meta.title) {
        let title = to.meta.title;
        if (typeof title == 'function') {
            title = to.meta.title(to);
        }
        title = title.replace(/(?:^|\s|["'([{])+\S/g, (match) => match.toUpperCase());

        // Set module title
        to.meta.moduleTitle = title.charAt(0).toUpperCase() + title.slice(1);
    }

    if (to.meta.requiresAuthentication) {
        if (token) {
            if (!vue.$api.getAuthorization()) {
                vue.$api.setAuthorization(window.atob(token)); // window.atob(token)
            }

            const userInfo = vue.$cookies.get('user-info') != null ? JSON.parse(window.atob(vue.$cookies.get('user-info'))) : null;

            let merchantRole = userInfo.role.permissions['my-merchant-index'];

            // delete merchants index when my-merchant-index is available to avoid
            // conflict in permission
            if (merchantRole) {
                delete userInfo.role.permissions['merchants-index'];
            }

            // temporary add merchants-branches-update in permission
            // for question if needed in response
            // for now this will be available in all roles
            // userInfo.role.permissions['merchants-branches-update'] = true

            //set permision to cookies
            Object.keys(userInfo.role.permissions).find(function (key) {
                if (key === to.meta.action_id) {
                    vue.$cookies.set('permission', { name: to.name });
                }

                if (typeof to.meta.action_id === 'object') {
                    if (key === to.meta.action_id[to.params.action]) {
                        vue.$cookies.set('permission', { name: to.name });
                    }
                }
            });

            if (!userInfo) next();

            // filter default layout children routes with sequence property in meta
            const sequenceRoutes = router.options.routes[8].children
                .filter((route) => {
                    return route.meta.sequence;
                })
                .sort((a, b) => a.meta.sequence - b.meta.sequence);

            // find next available route base on sequence
            let nextRoute = sequenceRoutes.find((route) => {
                return Object.keys(userInfo.role.permissions).find(function (key) {
                    return route.meta.action_id === key;
                });
            });

            if (vue.$cookies.get('permission') == null) {
                vue.$cookies.set('permission', false);
                if (to.redirectedFrom) {
                    // next({ name: 'dashboard' })
                    next({ name: nextRoute.name || 'dashboard' });
                }

                if (to.redirectedFrom !== '/' && to.name !== 'dashboard') {
                    next({ name: 'page-not-found' });
                }
            }
            // console.log(to, nextRoute);
            next();
        } else {
            vue.$cookies.remove('token');
            vue.$api.setAuthorization(undefined);
            next({ name: 'login' });
            // next({ name: 'login', query: { redirect: to.name != 'merchants' ? to.name : undefined } });
        }
    } else {
        if (to.matched.length == 0) {
            next();
        } else if (token) {
            if (!vue.$api.getAuthorization()) {
                vue.$api.setAuthorization(window.atob(token));
            } // Decode Base64
            next({ name: 'default-layout' });
        } else {
            vue.$cookies.remove('token');
            vue.$cookies.remove('user-info');
            next();
        }
    }
});

export default router;
